<div class="form-panel-container">
    <form [formGroup]="formGroup">
        <div class="form-container" [ngClass]="{ readonly: _context?.mode === FormMode.Reading }">
            <div class="form-item form-item-help">
                <mat-form-field class="with-info-icon">
                    <mat-label>Nom</mat-label>
                    <input matInput data-input-name type="text" formControlName="name" autocomplete="off" required />
                    @if (formGroupErrors?.name?.required && (formGroup.controls['name']?.dirty || formGroup.controls['name'].touched)) {
                        <mat-error data-input-title-error>Le champ 'Nom' est obligatoire</mat-error>
                    }
                </mat-form-field>
                <fa-icon [icon]="faCircleInfo" class="info-icon" matTooltip="TODO Nom affiché" matTooltipPosition="right"></fa-icon>
            </div>

            <div class="form-item form-item-help">
                <mat-form-field class="with-info-icon">
                    <mat-label>Type</mat-label>
                    <mat-select data-select-type formControlName="viewType" required>
                        @for (type of viewTypes; track type) {
                            <mat-option data-select-listing-type-option [value]="type.id">{{ type.value }}</mat-option>
                        }
                    </mat-select>
                    @if (formGroupErrors?.viewType?.required && (formGroup.controls['viewType']?.dirty || formGroup.controls['viewType'].touched)) {
                        <mat-error data-input-title-error>Le champ 'Type' est obligatoire</mat-error>
                    }
                </mat-form-field>
                <fa-icon [icon]="faCircleInfo" class="info-icon" matTooltip="TODO Type" matTooltipPosition="right"></fa-icon>
            </div>

            <div class="form-item form-item-help">
                <mat-form-field class="with-info-icon">
                    <mat-label>Adresse d'emission par défaut</mat-label>
                    <mat-select data-select-address formControlName="defaultSendingAddressId" required>
                        @for (address of _context.addresses; track address) {
                            <mat-option data-select-listing-type-option [value]="address.id">{{ address.displayName }}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
                <fa-icon [icon]="faCircleInfo" class="info-icon" matTooltip="TODO Adresse d'emission par défaut" matTooltipPosition="right"></fa-icon>
            </div>
            <div class="form-item form-item-help">
                <mat-form-field class="with-info-icon">
                    <mat-label>Délai au delà duquel un dossier en attente d'archivage est archivé</mat-label>
                    <input matInput data-input-name type="text" formControlName="delayBeforeArchiving" autocomplete="off" required />
                </mat-form-field>
                <fa-icon [icon]="faCircleInfo" class="info-icon" matTooltip="Le délai est exprimé en jours" matTooltipPosition="right"></fa-icon>
            </div>
            <div class="form-item form-item-help">
                <mat-form-field class="with-info-icon">
                    <mat-label>Emetteur personnalisé pour l'envoi de SMS.</mat-label>
                    <input matInput data-input-name type="text" formControlName="smsOadc" autocomplete="off" />
                </mat-form-field>
                <fa-icon [icon]="faCircleInfo" class="info-icon" matTooltip="Emetteur personnalisé pour l'envoi de SMS." matTooltipPosition="right"></fa-icon>
            </div>
        </div>
    </form>
    <div class="buttons-container">
        <button mat-stroked-button class="accent-button" [disabled]="formGroup.disabled" [ngClass]="{ disabled: formGroup.invalid || formGroup.disabled }" (click)="cancel()">
            Annuler
        </button>
        <button
            mat-raised-button
            class="accent-button"
            [disabled]="formGroup.disabled || formGroup.invalid"
            [ngClass]="{ disabled: formGroup.invalid || formGroup.disabled }"
            (click)="manualSave()">
            Enregistrer
        </button>
    </div>
</div>
